<template>
  <div class="auth-query">
    <p class="title">认证查询</p>
    <p class="desc">查询结果将以邮件形式发送至指定邮箱</p>
    <el-form 
      :model="formData" 
      ref="form" 
      :rules="rules" 
      class="query-form"
    >
      <el-form-item prop="email">
        <el-input
          v-model="formData.email"
          placeholder="请输入您的邮箱地址*"
        ></el-input>
      </el-form-item>
      <el-form-item prop="content">
        <el-input
          v-model="formData.content"
          placeholder="请输入持证人姓名或证书编号*"
        ></el-input>
      </el-form-item>
      <div class="action-bar">
        <button 
          class="submit" 
          type="button" 
          @click="submit"
        >完成并提交</button>
      </div>
    </el-form>
    <p class="text">
      证书查询暂时由人工回复，工作时间为周一至周五10:00～18:00，如有不便，敬请谅解<br>
      线上查询系统正在开发中，敬请期待
    </p>
  </div>
</template>
<script>
  import axios from '../../common/axios.js';
  export default {
    name: 'auth-query',
    data() {
      return {
        formData: {
          content: '',
          email: ''
        },
        rules: {
          name: {
            required: true,
            message: '请输入持证人姓名或证书编号'
          },
          email: {
            required: true,
            message: '请输入您的邮箱地址'
          }
        }
      }
    },
    methods: {
      async submit() {
        try {
          await this.$refs.form.validate();
          let res = await axios({
            url: '/index/certification',
            params: this.formData
          });
          if (res.success) {
            this.$message({
              message: '稍后会有工作人员对您的邮件进行回复，请耐心等待邮件查收',
              type: 'success'
            });
            this.formData.content = '';
            this.formData.email = '';
            this.$refs.form.resetFields();
          }
        } catch(err) {
          if (err) {
            this.$message({
              message: err.failMsg || '提交失败，请稍后再试' ,
              type: 'error'
            });
          }
        }
      }
    }
  }
</script>